// Where we work - map
var map;
var center = new google.maps.LatLng(27.3622198, -27.0639235);
var markers = [];

function initMap() {
  if (map === undefined) {
    var map = new google.maps.Map(document.getElementById('map'), {
      center: center,
      zoom: 3,
      minZoom: 3,
      maxZoom: 11,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: false,
      draggable: true,
      disableDefaultUI: false,
      styles: [
        {
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "saturation": 36
            },
            {
              "color": "#333333"
            },
            {
              "lightness": 40
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#ffffff"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#d3a2a2"
            },
            {
              "lightness": 20
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#e3e3e3"
            },
            {
              "lightness": 17
            },
            {
              "weight": "1"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#1d3960"
            },
            {
              "weight": "0.01"
            }
          ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            },
            {
              "lightness": 21
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dedede"
            },
            {
              "lightness": 21
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "lightness": 17
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "lightness": 29
            },
            {
              "weight": 0.2
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "lightness": 18
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f2f2f2"
            },
            {
              "lightness": 19
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#0a6eb4"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        }
      ]
    });
  }

  var locations = {};

  $.getJSON("js/json/map.json", function(json) {
    $.each(json, function (index) {

        if (this.field_location !== '') {
          var location        = {};
          location.title      = this.title;
          location.type       = this.type;
          location.where        = this.where;
          location.lat        = this.field_location;
          location.lng        = this.field_location_1;
          locations[index] = location;
        }

    });

    var prev_infowindow = false;
    for (var key in locations) {
      var location      = locations[key];
      var contentString = '<div class="gm-style-iw"><div class="location-content">' + location.title + '</div><div class="location-where">(<span>Locations:</span> ' + location.where + ')</div></div>';

      var icon = 'images/icons/map-pin.svg';
      if (location.type === 'Page') {
          icon = 'images/icons/map-pin-red.svg';
      }

      var marker        = new google.maps.Marker({
        position: new google.maps.LatLng(location.lat, location.lng),
        icon: icon,
        type: location.type,
        map: map
      });
      marker.infowindow = new google.maps.InfoWindow({
        content: contentString
      });

      marker.addListener('click', function () {
        if (prev_infowindow) {
          prev_infowindow.close();
        }

        prev_infowindow = this.infowindow;
        this.infowindow.open(map, this);
      });
      markers.push(marker);
    }


    var markerCluster = new MarkerClusterer(map, markers, {
      styles: [
        {width: 53, height: 53, url: 'images/icons/markercluster/m.svg'}
      ]
    });

    google.maps.event.addListener(map, 'zoom_changed', function() {
      var zoomLevel = map.getZoom();
      if (zoomLevel <= 3) {
        map.setCenter(center);
      }
    });
  });
}

// Sets the map on all markers in the array.
function setMapOnAll(map) {
  for (var i = 0; i < markers.length; i++) {
    markers[i].setMap(map);
  }
}

// Removes the markers from the map, but keeps them in the array.
function clearMarkers() {
  setMapOnAll(null);
}

// Shows any markers currently in the array.
function showMarkers() {
  setMapOnAll(map);
}

// Deletes all markers in the array by removing references to them.
function deleteMarkers() {
  clearMarkers();
  markers = [];
}